import type { NavigateHandler } from "./types";

const LOGIN_PATH = "/account/login";

/** The customer account login page. */
export const login: NavigateHandler = {
	handler() {
		window.location.href = LOGIN_PATH;
	},
};
